export const Search = () => (
  <div className="col col-6 d-flex justify-content-end">
    <div className="search-block">
      <form action="" className="search-block__inner">
        <input
          type="text"
          placeholder="Search everything"
          className="search-block__input"
        />
        <div className="search-block__clear"></div>
        <button className="search-block__btn"></button>
      </form>
    </div>
  </div>
);
